"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsolidatedListCell = void 0;
var consolidated_list_cell_component_1 = require("./consolidated-list-cell.component");
Object.defineProperty(exports, "ConsolidatedListCell", { enumerable: true, get: function () { return consolidated_list_cell_component_1.ConsolidatedListCell; } });
